module.exports = __webpack_public_path__ + "img/4_07.1cfaafb2.jpg";